export default __webpack_public_path__ + "images/755b0030045174c16961af6a42a09a15.svg";